export const amlStatuses = [
  {
    label: "To be verified",
    value: "ToBeVerified",
  },
  {
    label: "Under verification",
    value: "UnderVerification",
  },
  {
    label: "Rejected transaction",
    value: "Confirmed",
  },
  {
    label: "Approved transaction",
    value: "Declined",
  },
];
